var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._b({
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "btn-top-primary v-btn--has-bg",
    attrs: {
      "icon": "",
      "fixed": "",
      "large": "",
      "color": "#000"
    },
    on: {
      "click": function ($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  }, 'v-btn', _vm.$attrs, false), [_c('icon-arrow-primary', {
    staticClass: "white--text",
    attrs: {
      "size": "small",
      "direction": "up"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }